import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import { EMPLOYEES_TYPE } from 'constants/employees'
import { toogleGender } from 'utils/employees'

function MachineWorkers({ className, superWorkers, workers, isProducing }) {
  const workersList = useMemo(() => [...Array(workers).keys()], [workers])
  const superWorkersList = useMemo(
    () => [...Array(workers + superWorkers).keys()].slice(workers),
    [superWorkers, workers]
  )

  const producingClass = isProducing ? 'machine-workers--producing' : ''

  return (
    <div className={`machine-workers ${className} ${producingClass}`}>
      {workersList.map((worker) => (
        <img
          key={`machine-stand-worker-${worker}`}
          src={toogleGender({ index: worker, unlock: true, type: EMPLOYEES_TYPE.worker })}
          className="machine-workers__worker"
          alt="worker"
        />
      ))}
      {superWorkersList.map((superWorker) => (
        <img
          key={`machine-stand-super-worker-${superWorker}`}
          src={toogleGender({
            index: superWorker,
            unlock: true,
            type: EMPLOYEES_TYPE.super_worker
          })}
          className="machine-workers__worker"
          alt="super worker"
        />
      ))}
    </div>
  )
}

MachineWorkers.propTypes = {
  className: PropTypes.string.isRequired,
  superWorkers: PropTypes.number.isRequired,
  workers: PropTypes.number.isRequired,
  isProducing: PropTypes.bool
}

MachineWorkers.defaultProps = {
  isProducing: false
}

export default memo(MachineWorkers)
